import { render, staticRenderFns } from "./Nomal.vue?vue&type=template&id=7547fdc5&scoped=true&"
import script from "./Nomal.vue?vue&type=script&lang=js&"
export * from "./Nomal.vue?vue&type=script&lang=js&"
import style0 from "./Nomal.vue?vue&type=style&index=0&id=7547fdc5&prod&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7547fdc5",
  null
  
)

export default component.exports